import $axios from '../../axios'
import _find from 'lodash/find'
import _some from 'lodash/some'
import _findIndex from 'lodash/findIndex'

const moduleFarm = {
    state: {
        farms: {},
        allBuildings: [],
        logs: [],
        filterActions: ['create', 'update', 'delete'],
        selectedFarm: null,
    },
    mutations: {
        addFarms: (state, data) => {
            state.farms = data
        },
        addFarm: (state, farm) => {
            state.farms.push(farm)
        },
        editFarm: (state, farm) => {
            const index = _findIndex(state.farms, { id: farm.id })
            let updatedFarms = state.farms
            updatedFarms.splice(index, 1, farm)
            state.farms = updatedFarms
        },
        removeFarm: (state, farmId) => {
            const index = _findIndex(state.farms, { id: farmId })
            state.farms.splice(index, 1)
        },
        addLogs: (state, data) => {
            state.logs = data
        },
        updateFilterAction(state, action) {
            if (state.filterBuildings.indexOf(action) >= 0) {
                state.filterBuildings.splice(state.filterBuildings.indexOf(action), 1)
            } else {
                state.filterBuildings.push(action)
            }
        },
        selectFarm: (state, id) => {
            state.selectedFarm = id
        },
        resetSelectedFarm: (state) => {
            state.selectedFarm = null
        },
        addBuildings: (state, data) => {
            state.allBuildings = data
        },
        addMilkInspection: (state, milkInspection) => {
            const index = _findIndex(state.farms, { id: milkInspection.farm })
            let updatedFarm = state.farms[index]
            updatedFarm.milkInspections.unshift(milkInspection)
            updatedFarm.lastMilkInspection = milkInspection.date
            let updatedFarms = state.farms
            updatedFarms.splice(index, 1, updatedFarm)
            state.farms = updatedFarms
        }
    },
    actions: {
        fetchFarms(context) {
            $axios.get('/api/farm/fetch').then(response => {
                context.commit('addFarms', response.data)
            })
        },
        fetchBuildings(context) {
            $axios.get('/api/farm/buildings').then(response => {
                context.commit('addBuildings', response.data)
            })
        },
        createFarm(context, farm) {
            $axios.post('/api/farm/create', farm).then(response => {
                context.commit('addFarm', response.data)
            })
        },
        updateFarm(context, farm) {
            $axios.post(`/api/farm/edit/${farm.id}`, farm).then(response => {
                context.commit('editFarm', response.data)
            })
        },
        deleteFarm(context, farmId) {
            $axios.get(`/api/triforce/delete/${farmId}`).then(() => {
                context.commit('removeFarm', farmId)
            })
        },
        resetFarm(context, id) {
            $axios.post(`/api/triforce/reset/${id}`).then(response => {
                context.commit('editFarm', response.data)
            })
        },
        createFarmuser(context, params) {
            return $axios.post('/api/farmuser/create/' + params[0], params[1]).then(response => {
                context.commit('editFarm', response.data)
                return response.data.users
            })
        },
        updateFarmuser(context, params) {
            return $axios
                .post('/api/farmuser/edit/' + params.linkId, params.role)
                .then(response => {
                    context.commit('editFarm', response.data)
                    return response.data.users
                })
        },
        deleteFarmuser(context, params) {
            return $axios
                .get('/api/farmuser/delete/' + params[0] + '/' + params[1])
                .then(response => {
                    context.commit('editFarm', response.data)
                    return response.data.users
                })
        },
        createBuilding(context, building) {
            $axios.post('/api/building/create/' + building.farmId, building).then(response => {
                context.commit('editFarm', response.data)
            })
        },
        updateBuilding(context, building) {
            $axios
                .post('/api/building/edit/' + building.farmId + '/' + building.id, building)
                .then(response => {
                    context.commit('editFarm', response.data)
                })
        },
        deleteBuilding(context, buildingId) {
            $axios
                .get('/api/building/delete/' + buildingId)
                .then(response => {
                    context.commit('editFarm', response.data)
                })
        },
        updateInspections(context, id) {
            $axios.post(`/api/triforce/updateInspection/${id}`).then(response => {
                context.commit('editFarm', response.data)
            })
        },
        updateAnimals(context, id) {
            $axios.post(`/api/triforce/updateAnimal/${id}`).then(response => {
                context.commit('editFarm', response.data)
            })
        },
        deleteInspection(context, params) {
            $axios.post('/api/milkinspection/delete/' + params[0] + '/' + params[1]).then(response => {
                context.commit('editFarm', response.data)
            })
        },
        fetchLogs(context) {
            $axios.get('/api/log/fetch/' + context.rootState.farm.selectedFarm).then(response => {
                context.commit('addLogs', response.data)
            })
        }
    },
    getters: {
        farms: state => state.farms,
        allBuildings: state => state.allBuildings,
        logs: state => state.logs,
        filterActions: state => state.filterActions,
        buildingToUpdate: state => state.buildingToUpdate,
        showBuildingForm: state => state.showBuildingForm,
        selectedFarmId: state => state.selectedFarm,
        selectedFarm: state =>
            _find(state.farms, function(f) {
                return f.id === state.selectedFarm
            }),
        isUserManager: (state, getters, rootState, rootGetters) => farm => {
            return _some(farm.users, { userId: rootState.profile.profile.id, role: 'manager'}) || rootGetters.isUserAdmin
        },
        isUserVisitor: (state, getters, rootState, rootGetters) => {
            if (state.selectedFarm !== null) {
                return _some(rootGetters.selectedFarm.users, { userId: rootState.profile.profile.id, role: 'visitor'})
                    && !rootGetters.isUserAdmin
            } else {
                return true
            }

        }
    }
}

export default moduleFarm
